import { Text } from '@querodelivery/uni-react';
import styles from './mission-change-log-diff-value.module.scss';

type MissionChangeLogDiffValueProps = {
  value: string;
  variant: 'previous' | 'new';
};

export const MissionChangeLogDiffValue = ({
  value,
  variant,
}: MissionChangeLogDiffValueProps) => {
  const isPrevious = variant === 'previous';
  return (
    <div
      className={[
        styles.container,
        isPrevious ? styles.previous : styles.new,
      ].join(' ')}
    >
      <Text
        lineHeight="lg"
        tone={isPrevious ? 'error' : 'success'}
        textDecorationLine={isPrevious ? 'line-through' : undefined}
        fontSize="sm"
        fontWeight={isPrevious ? 'semibold' : 'bold'}
      >
        {value}
      </Text>
    </div>
  );
};
